import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

//获取付款方信息查询
export function getCusPaybanksetList(cusId) {
  return request({
    url: urlPrefix + '/setpaybank/cus/list/'+cusId,
    method: 'get',
  });
}

//获取税务信息查询
export function getTaxInformationList(obj) {
  return request({
    url: urlPrefix + '/settaxinfo/page',
    method: 'post',
    data: obj,
  });
}

//获取发薪设置查询
export function getCusPaysetList(obj) {
  return request({
    url: urlPrefix + '/setrule/page',
    method: 'get',
    param: obj,
  });
}

//新增发薪设置方法调用所属机构
export function addCusPaysetList(obj) {
  return request({
    url: urlPrefix + '/setrule/add',
    method: 'post',
    data: obj,
  });
}
//修改发薪设置方法调用
export function updateCusPaysetList(obj) {
  return request({
    url: urlPrefix + '/setrule/update',
    method: 'post',
    data: obj,
  });
}
//删除发薪设置方法调用
export function deleteCusPaysetData(obj) {
  return request({
    url: urlPrefix + '/setrule/delete/'+obj,
    method: 'delete',
    data: obj,
  });
}

//新增付款方法调用
export function addCusPaybanksetList(obj) {
  return request({
    url: urlPrefix + '/setpaybank/add',
    method: 'post',
    data: obj,
  });
}
//修改付款设置方法调用
export function updateCusPaybanksetList(obj) {
  return request({
    url: urlPrefix + '/setpaybank/update',
    method: 'post',
    data: obj,
  });
}
//修改付款设置方法调用
export function deleteCusPaybanksetData(obj) {
  return request({
    url: urlPrefix + '/setpaybank/delete/'+obj,
    method: 'delete',
    data: obj,
  });
}

//新增付款方法调用
export function addTaxInformationList(obj) {
  return request({
    url: urlPrefix + '/settaxinfo/add',
    method: 'post',
    data: obj,
  });
}
//修改付款设置方法调用
export function updateTaxInformationList(obj) {
  return request({
    url: urlPrefix + '/settaxinfo/update',
    method: 'post',
    data: obj,
  });
}

//修改付款设置方法禁用或启用
export function updateEnableOrDisabled(obj) {
  return request({
    url: urlPrefix + '/settaxinfo/update-enable-or-disabled',
    method: 'post',
    data: obj,
  });
}

//修改付款设置方法调用
export function deleteTaxInformationData(obj) {
  return request({
    url: urlPrefix + '/settaxinfo/delete/'+obj,
    method: 'delete',
    data: obj,
  });
}

//测试下载模板api
export function downloadFileById(obj) {
  return request({
    url: urlPrefix + '/test/file/'+obj,
    method: 'post',
    data: obj,
  });
}

//根据所属机构orgId获取计薪规则 信息
export function getSetRuleByOrgId(obj,groupName,templateName) {
  return request({
    url: urlPrefix + '/setrule/getrule-byorgid/'+obj+'/'+groupName+'/'+templateName,
    method: 'get',
  });
}

//根据信息生成批次名称
export function getBatchNameNo(param) {
  return request({
    url: urlPrefix + '/setrule/getBatchNameNo',
    method: 'post',
    data:param
  });
}

